<template>
    <div class="bottom">
        <div class="bottom_con typeArea">
            <div class="bottom_nav">
            <div class="bottom-logo">
                <img src="../../assets/images/订好仓（白色）.png" />
            </div>
            <div class="bottom-nav">
                <div class="bottom_spanBox">
                <div
                    v-for="(item, index) in nav"
                    :key="index"
                    @click="handleClick(index, item.url)"
                >
                    {{ item.tit }}
                    </div>
                </div>
                
                <!-- <div class="dailishang">
                    <div>
                      <a href="https://dhctest.yunfangshi.com/admin/"  target="_blank">服务商</a>
                      <img src="../../assets/images/you.png" alt="">
                    </div>
                </div> -->
            </div>
            </div>
            <div class="bottom_line"></div>
            <div class="bottom_phone">
            <div>
                <p>客服电话：</p>
                <p>400-808-6228</p>
            </div>
            <div>
                <p>联系邮箱：</p>
                <p>service@dhcang.com</p>
            </div>
            <div>
                <p>联系地址：</p>
                <p>青岛市市北区徐州路160号宇恒大厦702室</p>
            </div>
            <div  class="bottom_phone_p">
                <p>
                <img src="../../assets/images/xcx.png" alt="">
                </p>
                <p>小程序</p>
            </div>
            <div class="bottom_phone_p">
                <p>
                <img src="../../assets/images/fwh.jpg" alt="">
                </p>
                <p>公众号</p>
            </div>
            </div>
            <p class="Copyright">
            <!-- Copyright © 2023 dhcang.com. 订好舱（鲁ICP备2025161466号） -->
            Copyright © 2025 dhcang.com. All rights reserved. 订好舱（鲁ICP备2025161466号）版权所属：订好舱物流科技（青岛）有限公司
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            nav: [
              {
                tit: "首页",
                url: "/index",
              },
              {
                tit: "精选运价",
                url: "/SelectedFreightRates",
              },
              {
                tit: "现舱市场",
                url: "/Market",
              },
              {
                tit: "船东SPOT",
                url: "/ShipSPOT",
              },
              {
                tit: "美加到门",
                url: "/USToDoor",
              },
              {
                tit: "盯舱宝",
                url: "/StareAt",
              },
              {
                tit: "工具",
                url: "/Tool",
              },
            ],
        }
    },
    methods:{
      // 点击导航栏
      handleClick(index, url) {
        sessionStorage.setItem("lineIndex", index);
        if (!localStorage.getItem('isLogin')) {
          if (index != 0) {
            this.dialogVisible = true;
          }
        } else {
          if (this.$route.path != url) {
            this.$router.push(url);
          } else {
            window.scrollTo(0, 0);
          }
          this.highlightedIndex = index;
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}
.bottom{
  width: 100%;
  // height: 405px;
  background: #051332;
  border-radius: 0px 0px 0px 0px;
  .bottom_nav{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top:40px;
    padding-bottom:38px;
    border-bottom: solid 1px #4D5669;
    .bottom-logo{
      img{
        width: 122px;
        height: 40px;
      }
    }
    .bottom_spanBox{
      color: #fff;
      font-size: 18px;
      div{
        margin: 0 20px;
        cursor: pointer;
      }
    }

    .dailishang{
      vertical-align: middle;
      color: #fff;
      padding-left: 20px;
      border-left: 1px #fff solid;
      font-size: 18px;
      a{
        color: #fff;
        text-decoration: none;
      }
      div{
        display: flex;
      }
      img{
        width:20px;
        margin-left: 8px;
      }
    }
  }

  .bottom_phone{
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .bottom_phone_p{
      margin-top: 40px;
      p{
        text-align: center;
      }
      img{
        width: 112px;
        height: 112px;
        border-radius: 0px 0px 0px 0px;
      }
    }
  }
  
  .Copyright{
    color: #C7D9FF;
    text-align: center;
    margin-bottom: 20px;
  }
}

.bottom-nav,.bottom_spanBox{
    display: flex;
}
</style>